import React, {useState} from 'react';
import ImagePreview from "../../ImagePreview";
import {InteractionsPreviewItem} from '../InteractionsMenuItems';
import DocumentPreview from "./DocumentPreview";
import mime from "mime-types";
import styles from './styles.module.scss';

const EditMetaDataItem = ({
                            mimeType,
                            fileID,
                            fileName,
                            fileTypeID,
                            fileExtension,
                            updateFileMetadata,
                            getFileList,
                            getFile,
                            editPDFPages,
                            showGlobalErrorMessage,
                            editFormValues,
                            shumaId,
                            shumaIDForFile
                          }) => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(null);
  const [, setFileType] = useState(null);

  const getType = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return 'pdf';
      case 'image/gif':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/tiff':
      case 'image/png':
        return 'image';
      default:
        return null;
    }
  };
  const updateFile = async () => {
    try {
      setFileType(null);
      setContent(null);
      const body = await getFile({shumaId, fileID});
      const mimeType = mime.lookup(fileExtension);
      const dataUri = `data:${mimeType};base64,${body}`;
      setContent(dataUri);
      setFileType(getType());
      return dataUri;
    } catch (e) {
      setFileType(null);
      showGlobalErrorMessage(e.message)
    }
  };
  const handleOpen = async () => {
    if (!Boolean(content) && shumaIDForFile) {
      setLoading(true);
      await updateFile();
    }
    setLoading(false);
  };
  const handleVisitDateApprove = (image, payload) => {
    const {freeText, freeID} = payload;
    updateFileMetadata({
      shumaId,
      fileID,
      freeText,
      freeID,
    })
      .then(() => getFileList({shumaId}))
  };

  const EditButton = ({
                        mimeType,
                      }) => {
    const renderButton = () => {
      switch (mimeType) {
        case 'application/pdf':
          return (
            <DocumentPreview
              fileName={fileName}
              fileID={fileID}
              content={content}
              shumaId={shumaId}
              editPDFPages={editPDFPages}
              getFileList={getFileList}
              updateFile={updateFile}
            />
          );
        case 'image/gif':
        case 'image/jpeg':
        case 'image/tiff':
        case 'image/png':
          return (
            <ImagePreview
              id={fileID}
              Button={InteractionsPreviewItem({
                icon: null,
                label: fileName,
                onClick: handleOpen,
                customClassnames: styles.editMetaDataButton
              })}
              image={content}
              formInitialValues={editFormValues}
              onConfirm={handleVisitDateApprove}
              onReject={() => {
              }}
              loading={loading}
              formFields={fileTypeID === 11 ? 'freeTextAndFloors' : 'onlyFreeText'}
            />
          );
        default:
          return (
            <span
              style={{
                fontWeight: 500,
                fontSize: 14,
                color: '#505050',
                cursor: 'default',
                height: 24
              }}
            >
              {fileName ?? null}
            </span>);
      }
    };

    return renderButton();
  };

  return <EditButton mimeType={mimeType}/>
};

export default EditMetaDataItem;